import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { wrap } from "comlink";

var camelToSnake = function camelToSnake(str) {
  return str.replace(/([A-Z]?[a-z]+)/g, function (group) {
    return group.toLowerCase() + "_";
  }).slice(0, -1);
};

var configProps = ["gridSize", "averageCenter", "logTime", "onlyReturnModifiedClusters"];

var mapConfigNames = function mapConfigNames(config) {
  var wasmConfig = {};
  configProps.forEach(function (property) {
    if (config[property] !== null || config[property] !== undefined) {
      wasmConfig[camelToSnake(property)] = config[property];
    }
  });
  return wasmConfig;
};

var mergeModifiedClusters = function mergeModifiedClusters(prevClusters, modifiedClusters) {
  modifiedClusters.forEach(function (modifiedCluster) {
    var index = prevClusters.findIndex(function (prevCluster) {
      return prevCluster.uuid === modifiedCluster.uuid;
    });

    if (index === -1) {
      prevClusters.push(modifiedCluster);
    } else {
      prevClusters[index] = modifiedCluster;
    }
  });
  return prevClusters;
};

var WasmMarkerClusterer =
/** @class */
function () {
  function WasmMarkerClusterer() {
    var _this = this;

    this.config = {
      onlyReturnModifiedClusters: true
    };
    this.previousZoom = -1;
    this.previousClusters = [];
    this.worker = new Worker("./worker", {
      type: "module"
    });
    this.clusterer = wrap(this.worker);
    this.wasmReady = new Promise(function (resolve) {
      _this.wasmResolve = resolve;
    });
    /**
     * Merges any passed config parameters into existing config.
     *
     * Clears cached clusters if `averageCenter` or `gridSize` is modified.
     */

    this.configure = function (config) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.wasmReady];

            case 1:
              _a.sent();

              if (this.config.averageCenter != config.averageCenter || this.config.gridSize !== config.gridSize) {
                this.clearClusters();
              }

              this.config = Object.assign(this.config, config);
              return [2
              /*return*/
              , this.clusterer.configure(mapConfigNames(this.config))];
          }
        });
      });
    };
    /**
     * Calculates clusters for the markers within the given bounds.
     *
     * @returns Newly calculated clusters merged with any previously calculated clusters
     */


    this.clusterMarkersInBounds = function (bounds, zoom) {
      return __awaiter(_this, void 0, void 0, function () {
        var zoomChanged, wasmClusters;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.wasmReady];

            case 1:
              _a.sent();

              zoomChanged = zoom !== this.previousZoom;
              this.previousZoom = zoom;
              if (this.config.logTime) console.time("wasm");
              return [4
              /*yield*/
              , this.clusterer.clusterMarkersInBounds(bounds, zoom)];

            case 2:
              wasmClusters = _a.sent();
              if (this.config.logTime) console.timeEnd("wasm");
              this.previousClusters = !this.config.onlyReturnModifiedClusters || zoomChanged ? wasmClusters : mergeModifiedClusters(this.previousClusters, wasmClusters);
              return [2
              /*return*/
              , this.previousClusters];
          }
        });
      });
    };
    /**
     * Add an array of lat/lng markers so that they can be clustered.
     */


    this.addMarkers = function (markers) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.wasmReady];

            case 1:
              _a.sent();

              return [2
              /*return*/
              , this.clusterer.addMarkers(markers)];
          }
        });
      });
    };
    /**
     * Clears all added markers and calculated clusters.
     */


    this.clear = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.wasmReady];

            case 1:
              _a.sent();

              this.previousClusters = [];
              return [2
              /*return*/
              , this.clusterer.clear()];
          }
        });
      });
    };
    /**
     * Clears only calculated clusters.
     */


    this.clearClusters = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.wasmReady];

            case 1:
              _a.sent();

              this.previousClusters = [];
              return [2
              /*return*/
              , this.clusterer.clearClusters()];
          }
        });
      });
    };

    var onReady = function onReady(event) {
      if (event.data && event.data.ready === true) {
        _this.wasmResolve();

        _this.worker.removeEventListener("message", onReady);
      }
    };

    this.worker.addEventListener("message", onReady);
  }

  return WasmMarkerClusterer;
}();

export { WasmMarkerClusterer };